"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
exports.Section = function (_a) {
    var title = _a.title, description = _a.description, animationIndex = _a.animationIndex, children = _a.children, otherProps = __rest(_a, ["title", "description", "animationIndex", "children"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ animationIndex: animationIndex }, otherProps),
        react_1.default.createElement(styles_1.Title, null, title),
        description && react_1.default.createElement(styles_1.Description, null, description),
        react_1.default.createElement(styles_1.Divider, null),
        children));
};
exports.Section.defaultProps = {
    animationIndex: 0,
};
//# sourceMappingURL=index.js.map